module.exports = __webpack_public_path__ + "img/login_bgc.65fc76b1.png";